module.exports = __webpack_public_path__ + "img/column_archaeology.f3a3d9fc.png";